import { render, staticRenderFns } from "./LandingLive.vue?vue&type=template&id=7113c249&"
import script from "./LandingLive.vue?vue&type=script&lang=js&"
export * from "./LandingLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports